export const WORKLINE_FILTERS = Object.freeze({
    EVERYONE: {
        label: "Everyone",
        value: "everyone",
        showTooltip: true,
        tooltipText:
            "Lets you see everyone in the organisation, who has shifted-in/out today. Those who are yet to shift-in will be excluded.",
    },
    DIVISIONS: {
        label: "Divisions",
        value: "divisions",
        showTooltip: true,
        tooltipText:
            "Lets you see associates only from the selected division(s), who have shifted-in/out today, along with the organisation owner and admins. Those who are yet to shift-in, or those who are not from the selected division(s) will be excluded.",
    },
    REPORTS_TO_ME: {
        label: "Reports to me",
        value: "reports_to_me",
        showTooltip: true,
        tooltipText:
            "Lets you see those who directly report to you, or have been assigned tasks by you; along with the organisation owner and admins, and the chain of people you report to, including all your Division-Heads. All others, and those who are yet to shift-in will be excluded.",
    },
});

export const WORKLINE_SORT_OPTIONS = Object.freeze([
    {
        label: "By Seniority",
        value: "seniority",
        showTooltip: true,
        tooltipText:
            "Sorts your workline with senior people at the top; where seniority is defined by the seniority level assigned to an associate, or the Division-Head or Sub-Division-Head positions given to an associate.",
    },
    {
        label: "By Name (A-Z)",
        value: "name",
        showTooltip: true,
        tooltipText: "Sorts your workline alphabetically.",
    },
    {
        label: "By Shift-In Time",
        value: "shift_in",
        showTooltip: true,
        tooltipText:
            "Sorts your workline based on when people started their day.",
    },
]);

export const WORKLINE_GROUP_OPTIONS = Object.freeze([
    {
        label: "By Division",
        value: "group_by_division",
        showTooltip: true,
        tooltipText:
            "Lets your workline collapse/expand under the Division-Heads defined in your organisation. Clicking a Division Head, expands to reveal the associates in that division.",
    },
]);
